import { render, staticRenderFns } from "./ReportsGroupTable.vue?vue&type=template&id=8cef5880"
import script from "./ReportsGroupTable.vue?vue&type=script&lang=js"
export * from "./ReportsGroupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports